import { getUserDetailsApi } from "@/apis/profile/getUserDetails";
import { useQuery } from "@tanstack/react-query";
import { COOKIE_NAMES } from "@/constants/auth";
import { getCookie } from "@/utils/cookies";


export const useGetUserProfile = () => {
    const token = getCookie(COOKIE_NAMES.ACCESS_TOKEN);

    return useQuery({
        queryKey: ["getUserProfile", token],
        staleTime: 5 * 60 * 1000,
        refetchOnMount: false,
        enabled: Boolean(token),
        
        queryFn: () => getUserDetailsApi(),
    });
};

export const useGetUserStatus = useGetUserProfile;
